export const ONBOARDING_FLAG_KEY = 'onboardingCookieSet'
